import React, { useEffect } from "react";
import CreatableSelect from "react-select/creatable";
import { useState } from "react";
import { toast } from "react-toastify";
import axiosinstances from "../../Helper/useAxios";
import { useSelector } from "react-redux";


export default function ChangeOperator({ stylesofStypeNew,setIsChangeoperator,isChangeoperator }) {
  const [axiosInstance] = axiosinstances();
  const [mobile, setMobile] = useState("");
  const [mobileDetails, setMobileDetails] = useState(null)
  const [isMobileSearched, setIsMobileSearched] = useState(false)
  const [loading, setLoading] = useState(false)
  const [operators, setOperators] = useState(
    { value: "", label: "" },
  );
  const e = JSON.parse(sessionStorage.getItem("token"));
  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
// console.log('operators',operators)
// console.log('mobileDetails', mobileDetails)
  const operatorList = process.env.REACT_APP_OPERATOR;
  var allOperatorList = JSON.parse(operatorList);
  const handleChangeOperator = (newValue, actionMeta) => {
    let values = newValue?.value;
    const newValues = { value: values, label: values.toUpperCase() }
    setOperators(newValues);
    console.groupEnd();
  };
  const getoperatorBymobile = async (search) => {
    setIsMobileSearched(false)
    const response = await axiosInstance
      .get(
        `/api/v1/catalog/mobile/cache/get/${search}`,
        {
          headers: {
            Authorization: `Bearer ${e}`,
            "client-id": id,
            role: "ROLE_RETAILER_FINXPAY",
          },
        }
      )
      .then((res) => {
        if(res.data !== undefined &&  res?.data?.operator !== null){
          setMobileDetails(res?.data)
          res?.data?.operator ?  setOperators({value: res?.data?.operator, label: res?.data?.operator.toUpperCase()}) : 
          setOperators({value: '', label: ''})  
          setIsMobileSearched(true)
        } else{
          setOperators({value: '', label: ''}) 
          setMobileDetails(null) 
          setIsMobileSearched(true)
        }
        
      })
      .catch((err) => {
        console.log(err)
      });
  };
  useEffect(()=>{
    if(mobile.length == 10){
      getoperatorBymobile(mobile)
    }
  },[mobile])

  const updateNumber = async (search) => {
    setLoading(true)
    const response = await axiosInstance
      .post(
        `/api/v1/catalog/mobile/cache/update`,
        {
          "id":mobile,
          "operator":operators?.value,
          "circle":mobileDetails.circle
        },
        {
          headers: {
            Authorization: `Bearer ${e}`,
            "client-id": id,
            role: "ROLE_RETAILER_FINXPAY",
          },
        }
      )
      .then((res) => {
        setLoading(false)
       res.status == 200 && toast.success("Operator Updated Successfully")
      })
      .catch((err) => {
        console.log(err)
        toast.error("Operator has not Updateded, try again")
        setLoading(false)
      });
  };
  
  return (
    <div className="row col-12">
      <div class="col-12 col-sm-3 mb-2">
        <div class="form-floating">
          <input
            type="text"
            class="form-control"
            id="RetailerID"
            placeholder="Enter 10 digit mobile for auto search"
            value={mobile}
            maxLength={10}
            onChange={(e) => setMobile(e.target.value)}
          />
          <label for="RetailerID">Mobile</label>
          <small style={isMobileSearched && operators.value !== '' && mobile.length == 10  ? {color:'green'}: {color:'red'}} >{ isMobileSearched && operators.value == ''  && mobile.length == 10  ? "unable to find this number, try another mobile" 
          : isMobileSearched && operators.value !== '' && mobile.length == 10 ? 'enter number is valid'
          : 'enter 10 digit mobile for auto search **'}</small>
        </div>
      </div>
      
      <div class="col-12 col-sm-3 mb-2">
        <div className="selct-search-drop">
          <label>Select Operator</label>
          <CreatableSelect
            isClearable
            components={{
              IndicatorsContainer: () => null,
              IndicatorSeparator: () => null,
            }}
            value={operators}
            name="categoryCode"
            onChange={handleChangeOperator}
            // onInputChange={handleInputChange}
            options={allOperatorList}
            styles={stylesofStypeNew}
          />
        </div>
        
        
      </div>
      <div class="col-12 col-sm-2 mb-2">
      <button
            type="button"
            className="btn dbbtn  float-right"
            // disabled={checkAddReachargeDisable()}
            style={{background:'rgb(159, 166, 178)'}}
            onClick={() => setIsChangeoperator(!isChangeoperator)}
          >
          { isChangeoperator && 'cancel' }
          </button>
        <button style={{marginRight:'5px'}} type="button"
        disabled={mobileDetails == null || operators.value == '' || loading}
        onClick={updateNumber} className="btn dbbtn float-right" >
        Update
      </button>
        </div>
    </div>
  );
}
